export const buildMultipartFormData = <T extends object>(formData: T, formElement?: HTMLFormElement) => {
  const formDataObj = new FormData(formElement);

  Object.entries(formData).forEach(([key, value]) => {
    formDataObj.append(key, value);
  });

  return {
    body: formDataObj,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
};
